

export class LanguageStatusInput implements ILanguageStatusInput {
    /** The auto-generated id of the language master */
    languageId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ILanguageStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LanguageStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILanguageStatusInput {
    /** The auto-generated id of the language master */
    languageId: number;
    /** The updated status */
    status: number;
}

